<ng-container *ngIf="configuration">
  <p-floatLabel [ngClass]="configuration.scssClass">
      <h4 [for]="configuration.Id" class="mb-3 mt-4">{{configuration.Label}}</h4>
      <p-inputNumber [inputId]="configuration.InputId" [id]="configuration.Id" [formControl]="configuration.Control"  [format]="false" mode="decimal" 
      [minFractionDigits]="3" 
      [maxFractionDigits]="5" [min]="configuration.Min"
      [max]="configuration.Max"/>
  </p-floatLabel>
</ng-container>
